if (!customElements.get('scroll-to-next-section')) {
  class ScrollToNextSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents = () => {
      this.addEventListener('click', (event) => {
        const nextSection = this.closest('.shopify-section')?.nextElementSibling;
        const header = document.querySelector('[data-header]');

        nextSection && window.scrollTo({
          top: window.pageYOffset + nextSection.getBoundingClientRect().top - header.getBoundingClientRect().top,
          left: 0,
          behavior: 'smooth'
        });
      });
    };
  }
  customElements.define('scroll-to-next-section', ScrollToNextSection);
}
